import { Notification } from "./Dtos";
import { signalRService } from "./SignalRService";

export interface NotificationServiceConfig {
  userId: string;
  schoolId: string;
}

export class NotificationService {
  private config: NotificationServiceConfig | null = null;
  private onNotificationReceivedCallback:
    | ((notification: Notification) => void)
    | null = null;
  private onBroadcastReceivedCallback:
    | ((notification: Notification) => void)
    | null = null;

  constructor() {
    this.setupEventHandlers();
  }

  public connect(config: NotificationServiceConfig): void {
    this.config = config;
    signalRService.connect().then(() => {
      signalRService.joinSchoolGroup(
        this.config!.userId,
        this.config!.schoolId
      );
    });
  }

  private setupEventHandlers() {
    const { connection } = signalRService;

    connection.on("ReceiveNotification", (notification: Notification) => {
      if (this.onNotificationReceivedCallback) {
        this.onNotificationReceivedCallback(notification);
      }
    });

    connection.on("ReceiveBroadcast", (notification: Notification) => {
      if (this.onBroadcastReceivedCallback) {
        this.onBroadcastReceivedCallback(notification);
      }
    });
  }

  public disconnect(): void {
    signalRService.disconnect();
  }

  public onNotificationReceived(
    callback: (notification: Notification) => void
  ): void {
    this.onNotificationReceivedCallback = callback;
  }

  public onBroadcastReceived(
    callback: (notification: Notification) => void
  ): void {
    this.onBroadcastReceivedCallback = callback;
  }

  public isConnected(): boolean {
    return signalRService.connection.state === "Connected";
  }
}

export const notificationService = new NotificationService();
